
import VueSlickCarousel from 'vue-slick-carousel';
export default {
    name: "QdapHomeBriefSection",

    components: { VueSlickCarousel },

    props: {

        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
            settings: {
                arrows: true,
                dots: true,
                adaptiveHeight: true,
                autoplay: false,
                lazyLoad: 'progressive',
                responsive: [],
            },
        }
    },



    mounted() {
    },
    methods: {
    },
}
